var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("div", { staticClass: "title-con" }, [
        _c("div", { staticClass: "return-btn-con" }, [
          _c(
            "button",
            {
              staticClass: "return-btn",
              on: {
                click: function ($event) {
                  return _vm.$router.push({ path: "/box/special" })
                },
              },
            },
            [
              _c("c-svg", {
                attrs: {
                  src: "return.svg",
                  width: "21",
                  height: "21",
                  fill: "rgb(217, 222, 229)",
                },
              }),
            ],
            1
          ),
        ]),
        _c("h1", { staticClass: "case-title" }, [
          _vm._v(_vm._s(_vm.case_info.caseName)),
        ]),
        _c("div", { staticClass: "block" }),
      ]),
      _c("div", { staticClass: "case-open" }, [
        _c("div", { staticClass: "case-con" }, [
          _c("div", { staticClass: "case-img-con" }, [
            _vm.case_info.casePic
              ? _c("div", { staticClass: "case-img" }, [
                  _c("img", {
                    attrs: { src: _vm._f("imgfilter")(_vm.case_info.casePic) },
                  }),
                ])
              : _vm._e(),
            _vm.case_info.itemPic
              ? _c("div", { staticClass: "case-img" }, [
                  _c("img", {
                    attrs: { src: _vm._f("imgfilter")(_vm.case_info.itemPic) },
                  }),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "ctrl-con" }, [
          _c("div", { staticClass: "open-count-con" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.case_info.useType == 0,
                    expression: "case_info.useType == 0",
                  },
                ],
                staticClass: "open-count",
              },
              [
                _c("div", { staticClass: "title" }, [_vm._v("开箱数量:")]),
                _vm._l(_vm.cateCaseNum(), function (number) {
                  return _c(
                    "div",
                    {
                      key: number + "_" + (number === _vm.case_open_number),
                      staticClass: "open-count-item",
                      class: { active: number === _vm.case_open_number },
                      on: {
                        click: function () {
                          if (!_vm.isRunning) {
                            _vm.case_open_number = number
                          }
                        },
                      },
                    },
                    [_vm._v(" x" + _vm._s(number) + " ")]
                  )
                }),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "con-btn" }, [
            _vm.case_info.useType != 3
              ? _c(
                  "button",
                  {
                    staticClass: "open-case-btn",
                    on: {
                      click: function () {
                        return _vm.case_open("normal")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " 打开 " +
                        _vm._s(_vm.case_open_number) +
                        "次 " +
                        _vm._s(_vm._f("conversion")(_vm.case_open_amount)) +
                        "  "
                    ),
                    _vm.case_info.price > 0
                      ? _c("c-svg", {
                          attrs: {
                            src: "bill.svg",
                            width: "12",
                            height: "12",
                            fill: "#4762f2",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.case_info.useType == 3
              ? _c(
                  "button",
                  {
                    staticClass: "open-case-btn",
                    on: { click: _vm.toggle_case_open_cdk_modal_show },
                  },
                  [_vm._v(" 输入CD-KEY ")]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "open-count-con select-box" }, [
            _c("div", { staticClass: "title" }, [_vm._v("快速选择:")]),
            _c(
              "div",
              { staticClass: "open-count" },
              _vm._l(
                _vm.cateCaseList(_vm.$route.query.name),
                function (case_item, case_item_index) {
                  return _c(
                    "div",
                    {
                      key: "" + case_item_index,
                      staticClass: "open-count-item",
                      class: {
                        active: _vm.$route.params.id == case_item.caseId,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.pathGo({
                            name: "exclusiveDetail",
                            params: case_item,
                            id: case_item.caseId,
                            category: _vm.$route.query.name,
                          })
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("conversion")(case_item.price)) +
                          " "
                      ),
                    ]
                  )
                }
              ),
              0
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "recent-drop-con" }, [
        _c("h2", { staticClass: "title" }, [_vm._v("最近掉落")]),
        _c(
          "div",
          { staticClass: "recent-drop" },
          _vm._l(_vm.drop_awards, function (item, award_index) {
            return _c(
              "div",
              { key: award_index, staticClass: "item" },
              [
                _c("c-award", {
                  staticClass: "award",
                  attrs: {
                    rarity: item.rarity,
                    picture: item.itempic,
                    name: item.itemname,
                    price: item.price,
                    width: "100%",
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "case-award" }, [
        _c("div", { staticClass: "case-award-title" }, [
          _c("div", { staticClass: "text" }, [_vm._v("此箱子包含以下物品")]),
          _c("div", { staticClass: "probability" }, [
            _c(
              "div",
              {
                staticClass: "ruler-text",
                on: {
                  click: function ($event) {
                    _vm.notice_modal_show = true
                  },
                },
              },
              [
                _c("span", [_vm._v("概率说明")]),
                _c("img", {
                  attrs: {
                    src: require("../../../../assets/images/help_fill.png"),
                    alt: "",
                  },
                }),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "case-award-list" },
          _vm._l(_vm.case_awards, function (item, award_index) {
            return _c(
              "div",
              { key: award_index, staticClass: "item" },
              [
                _c("c-award", {
                  staticClass: "award",
                  attrs: {
                    rarity: item.rarity,
                    picture: item.itempic,
                    name: item.itemname,
                    price: item.price,
                    rate: item.viewRate,
                    width: "100%",
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            closable: false,
            width: "'400rem'",
          },
          model: {
            value: _vm.is_case_open_cdk_modal_show,
            callback: function ($$v) {
              _vm.is_case_open_cdk_modal_show = $$v
            },
            expression: "is_case_open_cdk_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: _vm.case_info.caseName, has_close_button: "" },
              on: { close_button_click: _vm.toggle_case_open_cdk_modal_show },
            },
            [
              _c("div", { staticClass: "case-open-cdk app-form" }, [
                _c("p", { staticClass: "case-open-cdk__desc" }, [
                  _vm._v("请输入您的CD-KEY，以开启箱子"),
                ]),
                _c("label", { staticClass: "app-form__field" }, [
                  _c("div", { staticClass: "app-form__field_icon_input" }, [
                    _c("i", { staticClass: "ivu-icon ivu-icon-md-key" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.case_open_cdk,
                          expression: "case_open_cdk",
                        },
                      ],
                      staticClass: "app-form__field__input pad50",
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        placeholder: "请输入您的CD-KEY",
                      },
                      domProps: { value: _vm.case_open_cdk },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.case_open_cdk = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%" },
                  on: {
                    click: function ($event) {
                      return _vm.case_open("cdk")
                    },
                  },
                },
                [_vm._v(" 确认开箱 ")]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "开箱概率说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(" 每次开启盲盒为新的一轮"),
                  _c("span", [_vm._v("独立计算")]),
                  _vm._v(" ，多次开启盲盒并"),
                  _c("span", [_vm._v("不意味")]),
                  _vm._v("着某区间"),
                  _c("span", [_vm._v("概率累加")]),
                  _vm._v(" 。 "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例1：")]),
                _c("p", [
                  _vm._v(" 盲盒内有A、B两件饰品,获得概率都为"),
                  _c("span", [_vm._v("50%")]),
                  _vm._v(",当连续开启该盲盒时, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("开启结果"),
                  _c("span", [_vm._v("稳定")]),
                  _vm._v("为ABABAB "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例2：")]),
                _c("p", [
                  _vm._v(" 某饰品掉率为"),
                  _c("span", [_vm._v("10%")]),
                  _vm._v(", 当连续开启该盲盒时, "),
                  _c("span", [_vm._v("可能10次无掉落")]),
                  _vm._v("该饰品, 也可能20次掉落1次, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("每开10次"),
                  _c("span", [_vm._v("必定掉落")]),
                  _vm._v("1次该饰品 "),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("c-RewardModal", { ref: "case_reward_ui" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }